import { render, staticRenderFns } from "./act-list.vue?vue&type=template&id=496c85a9&scoped=true&"
import script from "./act-list.vue?vue&type=script&lang=js&"
export * from "./act-list.vue?vue&type=script&lang=js&"
import style0 from "./act-list.vue?vue&type=style&index=0&id=496c85a9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496c85a9",
  null
  
)

export default component.exports